module.exports = "data:image/webp;base64,UklGRigAAABXRUJQVlA4TBwAAAAvD8AEEA8wOfM/OQf5jgcICYjpntMtiOh/SosA"